import {Component, OnInit, ViewChild} from '@angular/core';
import {SnotifyService} from 'ng-snotify';
import {AppSettings} from '../../settings/app-settings';
import {MSupplierService} from './service/m-supplier.service';
import {MSupplier} from './model/m-supplier';

@Component({
  selector: 'app-m-supplier',
  templateUrl: './m-supplier.component.html'
})
export class MSupplierComponent implements OnInit {

  private mSuppliers: MSupplier [] = [];
  private filter: string;
  private mSupplier: MSupplier;
  private uiMode: string;
  @ViewChild('inputForm') inputForm;

  constructor(private mSupplierService: MSupplierService,
              private snotifyService: SnotifyService) {
    this.mSupplier = new MSupplier();
  }

  ngOnInit() {
    this.uiMode = 'IDEAL';
    this.loadMSupplier();
  }

  sumbmitFormData(): void {
    if (this.inputForm.invalid) {
      this.snotifyService.error('Fill All Input Text', AppSettings.MESSAGE_WARNING, {
        timeout: 2000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true
      });
    } else {
      this.snotifyService.confirm('Save ?..', AppSettings.MESSAGE_INFO, {
        timeout: 5000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.snotifyService.remove(toast.id);
              this.mSupplierService.save(this.mSupplier).subscribe((data) => {
                this.mSuppliers.push(data);
                this.snotifyService.success('Store Save Success!', AppSettings.MESSAGE_SUCCESS, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
                this.clearFormData();
              }, (e) => {
                this.snotifyService.error(e.error.message, AppSettings.MESSAGE_ERROR, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
              });
            }
          },
          {
            text: 'No', action: (toast) => {
              this.snotifyService.remove(toast.id);
            }, bold: true
          },
        ]
      });
    }
  }

  selectFormData(rowNo, mSupplier: MSupplier) {
    this.uiMode = 'SELECTED';
    this.mSupplier = mSupplier;
    this.mSuppliers.splice(rowNo, 1);
  }

  newFormData(): void {
    this.uiMode = 'EDIT';
  }

  clearFormData(): void {
    this.inputForm.reset();
    this.uiMode = 'IDEAL';
    this.loadMSupplier();
  }

  deleteFormData(): void {
    this.snotifyService.confirm('Delete ?..', AppSettings.MESSAGE_WARNING, {
      timeout: 5000,
      showProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      buttons: [
        {
          text: 'Yes', action: (toast) => {
            this.snotifyService.remove(toast.id);
            this.mSupplierService.delete(this.mSupplier.indexNo).subscribe((data) => {
                this.snotifyService.success('Store Delete Success!', AppSettings.MESSAGE_SUCCESS, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
                this.clearFormData();
              },
              (e) => {
                this.snotifyService.error(e.error.message, AppSettings.MESSAGE_ERROR, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
              });
          }
        },
        {
          text: 'No', action: (toast) => {
            this.snotifyService.remove(toast.id);
          }, bold: true
        },
      ]
    });
  }

  loadMSupplier(): void {
    this.mSupplierService.findAll().subscribe((mSuppliers) => {
        this.mSuppliers = mSuppliers;
      },
      (e) => {
        this.mSuppliers = [];
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/view/master-files/m-supplier/m-supplier.component.ts